import { assertServiceHost, axiosClient } from '@nx-frontend/shared/api';

export interface GetDomainExistsResponse {
  exists: boolean;
}

export async function getDomainExistsInternalApi({
  host,
  superSecret,
  domain,
}: {
  host: string;
  superSecret: string;
  domain: string;
}): Promise<GetDomainExistsResponse> {
  const response = await axiosClient.get<GetDomainExistsResponse>(`${assertServiceHost(host)}/v1/domainExists`, {
    params: {
      domain,
    },
    secret: superSecret,
  });
  return response.data;
}
